import { useQuery } from "react-query";
import DataService from "../../../config/DataServices";

const { getRequest } = DataService()

export const useAdminPlatformFee = () => {

    return useQuery({
        queryKey: ["admin-fee"],
        queryFn: () => {
            return getRequest("/avhbgcjdh")
        },
    })
}

export const useGetAdminFeeTransaction = ({ page, size, searchText, sortOrder, sortField, currency, network }) => {

    return useQuery({
        queryKey: ["adminfee-list", page, size, searchText, sortOrder, sortField, currency, network],
        queryFn: () => {
            return getRequest(`/atrqfjvhjs?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&network=${network}&currency=${currency}`)
        }
    })
}
